import Vue from 'vue'
import { Module, ActionContext } from 'vuex'
import {RootState, CalendarState, FeatureFlags} from './state_models'
import Calendar from '../models/calendar'
import set from "lodash-es/set"
import get from "lodash-es/get"
import {awaitToJS} from '@/util/await-to-js'
import LocationServices from "../services/LocationServices";
import CompanyService from "../services/CompanyService";
import { LocationMembership } from '../models'

export const featureFlags: Module<FeatureFlags, RootState> = {
  namespaced: true,
  state: { locationFeatureFlags: {}, companyFeatureFlags: {} },
  getters: {
    getForLocation: (state: FeatureFlags) => {
      return (key: string) => get(state.locationFeatureFlags, key)
    },
    getForCompany(state: FeatureFlags) {
      return (key: string) => get(state.companyFeatureFlags, key)
    }
  },
  mutations: {
    set: (
      state: FeatureFlags,
      payload: { locationFeatureFlags?: { [key: string]: any }; companyFeatureFlags?: { [key: string]: any } }
    ) => {
      if (payload.locationFeatureFlags) {
        state.locationFeatureFlags = payload.locationFeatureFlags
      }
      if (payload.companyFeatureFlags) {
        state.companyFeatureFlags = payload.companyFeatureFlags 
      }
    },
    updateFeatureFlag: (
      state: FeatureFlags,
      payload: { key: string; value: string; type: "location" | "company"}
    ) => {
      if(payload.type === "location"){
        state.locationFeatureFlags = set(state.locationFeatureFlags, payload.key, payload.value);
      }else{
        state.companyFeatureFlags = set(state.companyFeatureFlags, payload.key, payload.value);
      }

    },
  },
  actions: {
    async syncAll(
      context: ActionContext<FeatureFlags, RootState>,
      locationId: string
    ) {
      if (!locationId) {
        return
      }

      const [err, response] = await awaitToJS(LocationServices.Lab.getFeatureFlags(locationId))
      if(err){
        return
      }

      context.commit('set', {
        locationFeatureFlags: response?.featureFlags?.location,
        companyFeatureFlags: response?.featureFlags?.company
      })
    },
    async getFeatureFlags(
      context: ActionContext<FeatureFlags, RootState>,
      payload: { locationId?:string; companyId?:string;}
    ) {
      const {locationId, companyId} = payload

      if (!locationId && !companyId) {
        return
      }

      let err, response;

      if(locationId){
        [err, response] = await awaitToJS(LocationServices.Lab.getFeatureFlags(locationId))
      }else if (companyId){
        [err, response] = await awaitToJS(CompanyService.Lab.getFeatureFlags(companyId))
      }

      if(err){
        return
      }

      context.commit('set', {
        locationFeatureFlags: response?.featureFlags?.location,
        companyFeatureFlags: response?.featureFlags?.company
      })
    },
    async updateFeatureFlag(
      context: ActionContext<FeatureFlags, RootState>,
      payload: { locationId?:string; companyId?:string; key: string; value: string;}
    ) {
      const {locationId, companyId, key, value} = payload

      if (!locationId && !companyId) {
        return
      }

      const body = set({}, key, value);

      let err, response;

      if(locationId){
        [err, response] = await awaitToJS(LocationServices.Lab.upsertFeatureFlag(locationId, body))
      }else if (companyId){
        [err, response] = await awaitToJS(CompanyService.Lab.upsertFeatureFlag(companyId, body))
      }

      if(err){
        return
      }

      context.commit('updateFeatureFlag', {
        key,
        value,
        type: locationId ? "location" : "company"
      })

      if (locationId && key === 'membership.themesV2' && Boolean(value) == false) {
        const response = await LocationMembership.clearAppliedThemes(locationId)
       }
    }
  }
}
